import { render, staticRenderFns } from "./ParamTipoDocForm.vue?vue&type=template&id=283bcc0a"
import script from "./ParamTipoDocForm.vue?vue&type=script&lang=js"
export * from "./ParamTipoDocForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports